var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-0 p-0"},[_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"btn btn-success btn-sm ml-2",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.buttonText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }